import React from 'react';
import EntityPropsUpdater from '../../../component/EntityPropsUpdater';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { addNotification } from '../../../actions/NotificationsActions';
import LoaderCC from '../LoaderCC';
import { Button, Col } from 'react-bootstrap';
import axios from 'axios';
import FormInput from '../../forms/FormInput';


class LeadIframeIntegration extends EntityPropsUpdater {
  constructor(props) {
    super(props);
    this.state = {
      downloading: false,
      title: '',
      disabledDownload: false,
    };
  }

  componentDidMount = () => {
    const { entity, entityLoaded } = this.props;
    this.setState({
      title: entity.getTitle(),
      disabledDownload: !entityLoaded,
      entity: entity,
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.entity !== this.props.entity) {
      this.setState({
        title: this.props.entity.getTitle(),
        entity: this.props.entity,
      });
    }
    if (prevProps.entityLoaded !== this.props.entityLoaded) {
      this.setState({
        disabledDownload: !this.props.entityLoaded,
      });
    }
  }

  handleTitleChange = (name, value) => {
    this.setState({ title: value });
  };


  download = async () => {
    const { intl: { messages } } = this.props;
    const { title, entity } = this.state;
    let leadId = entity.getId();

    try {
      this.setState({ downloading: true });
      const response = await axios.get('/api/domainregistration/leads/' + leadId + '/downloadhtmlforiframe.json', {
        params: {
          title,
        },
        responseType: 'blob',
      });
      this.setState({ downloading: false });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      let fileName = title.replace(' ', '_').toLowerCase();
      link.setAttribute('download', fileName + '.html');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      this.setState({ downloading: false });
      this.props.doNotify('error', messages.iframe_implementation_file_download_failed.replace('%error%', error.message));
    }
  };

  render() {
    const { intl: { messages }, entityLoaded } = this.props;
    const { title, downloading, disabledDownload } = this.state;
    let output = [];
    if (!(entityLoaded)) {
      return (<LoaderCC />);
    } else {
      output.push(
        <div className="panel panel-transparent">
          <Col md={12}>
            <h3>
              {messages.iframe_implementation_file}
            </h3>
          </Col>
          <Col md={6}>
            <div className="form-group form-group-default p-t-10 p-b-10">

              <Col md={12}>
                <FormInput
                  type="text"
                  label={messages.title}
                  name="title"
                  onChange={this.handleTitleChange}
                  value={title}
                />
              </Col>
              <p></p>
              <Col md={12}>
                <Button
                  onClick={this.download}
                  disabled={title.trim() === '' || downloading || disabledDownload}>
                  {downloading ? <i className="far fa-spin fa-spinner-third" /> :
                    <i className="fas fa-download"></i>} {messages.export_download}
                </Button>
              </Col>
            </div>
          </Col>
        </div>,
      );

    }
    return (<div className="clearfix padding-25 sm-padding-10">{output}</div>);
  }
}


const mapStateToProps = state => {
  return {
    user: state.login.user,

  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(LeadIframeIntegration),
);

